export const ADD_TOAST = "ADD_TOAST"
export const REMOVE_TOAST = "REMOVE_TOAST"
export const REMOVE_ALL_TOASTS = "REMOVE_ALL_TOASTS"
